import { useEffect, useState } from "react";
import socket from "../../socket/socket";
import { trackCustomers } from "../../services/orderTrackService";

const useCustomers = (branchSwitch) => {
  const [customers, setCustomers] = useState([]);

  /** ---------------- FETCH ALL CUSTOMERS ---------------- **/
  const fetchCustomers = async () => {
    try {
      const res = await trackCustomers(branchSwitch);

      if (res.data.code === 1) {
        const raw = res.data.data || [];

        setCustomers(raw);
      }
    } catch (err) {
      console.error("Fetch Customers Error:", err);
    }
  };

  /** ---------------- SOCKET: ORDER UPDATE ---------------- **/
  useEffect(() => {
    const handleOrderUpdate = (data) => {
      if (!data) return;
      fetchCustomers();
    };

    socket.on("merchant:ordersUpdate", handleOrderUpdate);
    return () => socket.off("merchant:ordersUpdate", handleOrderUpdate);
    // eslint-disable-next-line
  }, []);

  /** ---------------- INITIAL LOAD ---------------- **/
  useEffect(() => {
    fetchCustomers();
    // eslint-disable-next-line
  }, []);

  return { customers };
};

export default useCustomers;
